import { styled } from '@mui/material/styles';

export const GroupItems = styled('ul')(() => ({
	paddingLeft: 0,
}));
